import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Star, MapPin, Car, ArrowRight } from "lucide-react";
import { initials } from "@/lib/format";

export function InstructorCard({ instructor }) {
  const navigate = useNavigate();
  return (
    <Card className="p-5 rounded-2xl border-border hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(0,168,232,0.1)] transition-transform duration-200 flex flex-col" data-testid={`instructor-card-${instructor.user_id}`}>
      <div className="flex items-center gap-4">
        <Avatar className="w-14 h-14 border border-border">
          <AvatarImage src={instructor.photo} alt={instructor.name} />
          <AvatarFallback className="bg-arctic-secondary text-arctic-accent font-heading">{initials(instructor.name)}</AvatarFallback>
        </Avatar>
        <div className="min-w-0">
          <div className="font-heading font-semibold text-arctic-secondary truncate">{instructor.name}</div>
          <div className="flex items-center gap-1 text-sm text-amber-500">
            <Star className="w-4 h-4 fill-amber-400 text-amber-400" /> {instructor.rating?.toFixed(1)}
            <span className="text-muted-foreground">· {instructor.experience_years} yrs</span>
          </div>
        </div>
      </div>
      <p className="mt-4 text-sm text-muted-foreground line-clamp-2 flex-1">{instructor.bio || "Experienced driving instructor."}</p>
      <div className="mt-4 space-y-1.5 text-sm text-muted-foreground">
        {instructor.location && <div className="flex items-center gap-2"><MapPin className="w-4 h-4" /> {instructor.location}</div>}
        {instructor.vehicle && <div className="flex items-center gap-2"><Car className="w-4 h-4" /> {instructor.vehicle}</div>}
      </div>
      <div className="mt-4 flex items-center justify-between">
        <span className="font-heading font-bold text-arctic-secondary">${instructor.hourly_rate}<span className="text-xs font-normal text-muted-foreground">/lesson</span></span>
        <Button size="sm" onClick={() => navigate(`/instructors/${instructor.user_id}`)} data-testid={`view-instructor-${instructor.user_id}`} className="rounded-full bg-arctic-primary hover:bg-arctic-primary/90">
          View & book <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      </div>
    </Card>
  );
}
